import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map, sumBy, filter } from 'lodash';
import MoneyDisplay from '../../../../components/money-display';
import NumberDisplay from '../../../../components/number-display';

class StatusRowComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalAccounts: 0,
      totalTTM: 0,
      totalLTV: 0,
    };
    this.calculate = this.calculate.bind(this);
  }

  componentWillMount() {
    this.props.api.addEventListener('modelUpdated', this.calculate);
  }
  componentDidMount() {
    this.calculate();
  }
  componentWillUnmount() {
    this.props.api.removeEventListener('modelUpdated', this.calculate);
  }

  calculate() {
    const allRows = map(filter(this.props.api.getModel().rowsToDisplay, { level: 0 }), 'data');
    const totalAccounts = allRows.length;
    const totalTTM = sumBy(allRows, 'ttm');
    const totalLTV = sumBy(allRows, 'ltv');
    this.setState({ totalAccounts, totalTTM, totalLTV });
  }
  
  render() {
    const { totalAccounts, totalTTM, totalLTV } = this.state;
    return (
      <div className="ag-status-panel">
        <div className="ag-name-value">
          <span>Total Accounts</span>: <span className="ag-name-value-value"><NumberDisplay value={totalAccounts} precision={0} /></span>
        </div>
        <div className="ag-name-value">&nbsp;&nbsp;|&nbsp;&nbsp;</div>
        <div className="ag-name-value">
          <span>Total TTM</span>: <span className="ag-name-value-value"><MoneyDisplay value={totalTTM} precision={2} abbreviated /></span>
        </div>
        <div className="ag-name-value">&nbsp;&nbsp;|&nbsp;&nbsp;</div>
        <div className="ag-name-value">
          <span>Total LTV</span>: <span className="ag-name-value-value"><MoneyDisplay value={totalLTV} precision={2} abbreviated /></span>
        </div>
      </div>
    );
  }
}

StatusRowComponent.propTypes = {
  api: PropTypes.shape({
    getModel: PropTypes.func,
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
  }).isRequired,
};
StatusRowComponent.defaultProps = {
};
export default StatusRowComponent;
